import React from "react";

const CardPaymentIcon = () => {
  return (
    <svg
      width="33"
      height="19"
      viewBox="0 0 33 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.178599"
        y="0.276042"
        width="31.991"
        height="17.6667"
        rx="1.16667"
        fill="white"
        stroke="#D9D9D9"
        stroke-width="0.333333"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.82491 12.3021H7.86668L6.39825 7.75269C6.32855 7.54342 6.18056 7.35841 5.96287 7.27121C5.41961 7.05208 4.82097 6.87769 4.16791 6.78974V6.61458H7.32246C7.75784 6.61458 8.08437 6.87769 8.13879 7.18326L8.9007 10.4649L10.858 6.61458H12.7618L9.82491 12.3021ZM13.8502 12.3021H12.0008L13.5237 6.61458H15.3731L13.8502 12.3021ZM17.7657 8.19116C17.8202 7.88483 18.1467 7.70968 18.5276 7.70968C19.1263 7.6657 19.7784 7.75366 20.3226 7.97203L20.6491 6.74748C20.1049 6.57233 19.5063 6.48438 18.963 6.48438C17.168 6.48438 15.8619 7.27218 15.8619 8.36555C15.8619 9.19734 16.7871 9.63408 17.4402 9.89719C18.1467 10.1595 18.4188 10.3347 18.3644 10.597C18.3644 10.9906 17.8202 11.1657 17.2769 11.1657C16.6238 11.1657 15.9708 11.0345 15.3731 10.8154L15.0465 12.0407C15.6996 12.2591 16.4061 12.347 17.0592 12.347C19.0719 12.3903 20.3226 11.6032 20.3226 10.4219C20.3226 8.93423 17.7657 8.84703 17.7657 8.19116V8.19116ZM26.795 12.3021L25.3265 6.61458H23.7493C23.4227 6.61458 23.0962 6.78974 22.9874 7.05208L20.2682 12.3021H22.172L22.552 11.4711H24.8912L25.1088 12.3021H26.795ZM24.0214 8.14844L24.5646 10.292H23.0418L24.0214 8.14844Z"
        fill="#172B85"
      />
    </svg>
  );
};

export default CardPaymentIcon;
